import { Component } from '@theme/component';

/**
 * Busca por voz do campo aberto do header.
 *
 * O botao de microfone so e revelado quando o navegador expoe a Web Speech API
 * (Chrome, Edge e Safari). Sem ela o campo segue funcionando como busca normal e
 * o botao continua oculto, para nao deixar um controle morto no layout.
 *
 * @extends {Component<{ micButton: HTMLButtonElement, input: HTMLInputElement }>}
 */
class HeaderSearchMofo extends Component {
  requiredRefs = ['input'];

  /** @type {any} */
  #recognition = null;

  connectedCallback() {
    super.connectedCallback();

    const SpeechRecognition = window.SpeechRecognition ?? window.webkitSpeechRecognition;
    const { micButton } = this.refs;

    if (!SpeechRecognition || !(micButton instanceof HTMLButtonElement)) return;

    this.#recognition = new SpeechRecognition();
    this.#recognition.lang = document.documentElement.lang || 'pt-BR';
    this.#recognition.continuous = false;
    this.#recognition.interimResults = false;

    this.#recognition.addEventListener('result', this.#onResult);
    this.#recognition.addEventListener('end', this.#onEnd);
    this.#recognition.addEventListener('error', this.#onEnd);

    micButton.addEventListener('click', this.#onMicClick);
    micButton.hidden = false;
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.refs.micButton?.removeEventListener('click', this.#onMicClick);

    if (!this.#recognition) return;

    this.#recognition.removeEventListener('result', this.#onResult);
    this.#recognition.removeEventListener('end', this.#onEnd);
    this.#recognition.removeEventListener('error', this.#onEnd);
    this.#stop();
  }

  #onMicClick = () => {
    if (!this.#recognition) return;

    if (this.refs.micButton?.dataset.listening === 'true') {
      this.#stop();
      return;
    }

    try {
      this.#recognition.start();
      if (this.refs.micButton) this.refs.micButton.dataset.listening = 'true';
    } catch {
      // start() lanca se ja houver uma sessao ativa; o estado e reposto no 'end'.
    }
  };

  /** @param {any} event */
  #onResult = (event) => {
    const transcript = event.results?.[0]?.[0]?.transcript;
    const { input } = this.refs;

    if (!transcript || !(input instanceof HTMLInputElement)) return;

    input.value = transcript;
    input.form?.requestSubmit();
  };

  #onEnd = () => {
    if (this.refs.micButton) delete this.refs.micButton.dataset.listening;
  };

  #stop() {
    try {
      this.#recognition?.stop();
    } catch {
      // Nada a fazer: parar uma sessao ja encerrada nao e erro para o usuario.
    }
    this.#onEnd();
  }
}

if (!customElements.get('header-search-mofo')) {
  customElements.define('header-search-mofo', HeaderSearchMofo);
}
